import { TipoEfectoI } from "interfaces/TipoEfecto";

export interface infoFetchTipoEfectoI {
  id: number | string;
  nombre: string;
}

class TipoEfecto implements TipoEfectoI {
  id: number | string;
  nombre: string;

  constructor(infoFetch: infoFetchTipoEfectoI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
  }
}

export const makeTipoEfecto = (infoFetch: infoFetchTipoEfectoI) => {
  return new TipoEfecto(infoFetch);
};
